import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { CustomerSearchModel } from '../../Models/Models/Customer/CustomerSearch/CustomerSearchModel';
import { CustomerStatus } from '../../Constants/Enums/Domain/CustomerStatus';
import { IJsonDate } from '../../System/IJsonDate';
import { RoleType } from '../../Constants/Enums/RoleType';
import { EntityType } from '../../Constants/Enums/EntityType';

declare var IS_RUNNING_IN_APP_POOL;

export class CustomerSearchClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(customerId: number, customerStatus: CustomerStatus, firstName: string, lastName: string, dateOfBirth: IJsonDate, taxIdentifier: string, clAccountId: string, customerRole: RoleType, entityId: number, entityType: EntityType, visibleToAdviserId: number, currentPage: number, pageSize: number): Promise<CustomerSearchModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/CustomerSearch/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId, customerStatus: customerStatus, firstName: firstName, lastName: lastName, dateOfBirth: dateOfBirth, taxIdentifier: taxIdentifier, clAccountId: clAccountId, customerRole: customerRole, entityId: entityId, entityType: entityType, visibleToAdviserId: visibleToAdviserId, currentPage: currentPage, pageSize: pageSize }

    return AjaxWrapper.get<CustomerSearchModel, any>(url, data);
  }
}

